import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { id: "servicii", label: "Servicii" },
  { id: "galerie", label: "Galerie" },
  { id: "despre", label: "Despre noi" },
  { id: "recenzii", label: "Recenzii" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    const sections = NAV.map((n) => document.getElementById(n.id)).filter(Boolean);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { threshold: 0.35 }
    );
    sections.forEach((s) => io.observe(s));

    return () => {
      window.removeEventListener("scroll", onScroll);
      io.disconnect();
    };
  }, []);

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[rgba(237,237,237,0.82)] backdrop-blur-lg border-b border-[var(--border-subtle)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between py-4 md:py-5">
        <button
          onClick={() => goTo("hero")}
          data-testid="header-logo-btn"
          className="flex items-center gap-3 focus-ring"
        >
          <div className="h-11 w-11 md:h-12 md:w-12 rounded-lg bg-white/95 flex items-center justify-center overflow-hidden shadow-[0_6px_20px_rgba(30,95,217,0.25)]">
            <img
              src="/images/logo.png"
              alt="Aurel Calin Premium"
              className="h-9 w-9 md:h-10 md:w-10 object-contain"
            />
          </div>
          <div className="hidden sm:flex flex-col leading-tight text-left">
            <span className="font-display text-[15px] md:text-[17px] font-semibold text-[var(--text-primary)]">
              Aurel Calin <span className="text-brand-blue">Premium</span>
            </span>
            <span className="text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-[var(--text-muted)]">
              Renovări & Construcții
            </span>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => goTo(n.id)}
              data-testid={`nav-${n.id}`}
              className={`link-underline text-sm font-medium text-[var(--text-secondary)] ${
                active === n.id ? "active" : ""
              }`}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:0746329111"
            data-testid="header-call-btn"
            className="btn-gold text-sm"
          >
            <Phone className="h-4 w-4" strokeWidth={2.4} />
            Sună acum
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden inline-flex items-center justify-center h-11 w-11 rounded-full border border-[var(--border-mid)] text-[var(--text-primary)] focus-ring"
          aria-label="Meniu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-500 ease-out ${
          open ? "max-h-[520px] opacity-100" : "max-h-0 opacity-0"
        } bg-[rgba(245,245,247,0.98)] backdrop-blur-lg border-t border-[var(--border-subtle)]`}
      >
        <div className="container-x py-6 flex flex-col gap-1">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => goTo(n.id)}
              data-testid={`mobile-nav-${n.id}`}
              className="text-left text-lg font-medium text-[var(--text-primary)] py-3 border-b border-[var(--border-subtle)] hover:text-[var(--brand-gold)] transition-colors"
            >
              {n.label}
            </button>
          ))}
          <a
            href="tel:0746329111"
            data-testid="mobile-call-btn"
            className="btn-gold mt-5 justify-center"
          >
            <Phone className="h-4 w-4" strokeWidth={2.4} />
            Sună acum · 0746 329 111
          </a>
        </div>
      </div>
    </header>
  );
}
